const getHotelSpecialOffers = (
  hotelResults,
  goldOffers,
  silverOffers,
  internationalOffers
) => {
  // -> SPECIAL OFFERS
  // Will need two result arrays - one paid, one nonpaid - all paid
  /**
	But for special offers will need to keep them separate, so in each rank array -
	filter out the hotels with special offers,
	split them into two arrays - gold, silver,
	then join -
	rank 1 gold + rank 2 gold, - full + shortlist  
	rank 1 silver + rank 2 silver - full + shortlist
	rank 3 gold + rank 4 gold, - stub full + stub shortlist  
	rank 3 silver + rank 4 silver - stub full + stub shortlist

	We leave extended out
	*/
  // Filter through both arrays and only push hotels that have offers
  const goldOfferHotels = hotelResults.map((rank) =>
    rank.filter((hotel) =>
      goldOffers.some((offer) => {
        if (offer.hotelId !== null) {
          return offer.hotelId._id === hotel._id;
        }
      })
    )
  );

  const silverOfferHotels = hotelResults.map((rank) =>
    rank.filter((hotel) =>
      silverOffers.some((offer) => {
        if (offer.hotelId !== null) {
          return offer.hotelId._id === hotel._id;
        }
      })
    )
  );

  const intlOfferHotels = hotelResults.map((rank) =>
    rank.filter((hotel) =>
      internationalOffers.some((offer) => {
        if (offer.hotelId !== null) {
          return offer.hotelId._id === hotel._id;
        }
      })
    )
  );

  // Order to add rankOne(gold), rankTwo(gold), rankOne(silver), rankTwo(silver),
  let specialOfferHotelResults = [
    goldOfferHotels[0],
    goldOfferHotels[1],
    silverOfferHotels[0],
    silverOfferHotels[1],
    goldOfferHotels[2],
    goldOfferHotels[3],
    silverOfferHotels[2],
    silverOfferHotels[3],
  ].flat();
  // remove duplicates & this is our main block of hotels
  specialOfferHotelResults = [...new Set(specialOfferHotelResults)];

  return specialOfferHotelResults;
};

export { getHotelSpecialOffers };
